import { createContext } from "react";
import type { Language } from "../model/language.ts";

export const LanguageContext = createContext<Language>("es");
